import { Injectable, Inject } from '@angular/core';
import { Location, DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';


@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  public path: string = '';

  constructor(
    /* tslint:disable:variable-name */
    @Inject(DOCUMENT) private _doc: Document,
    location: Location,
    router: Router,
    private localStorage: LocalStorageService)
    {
      router.events.subscribe(() => {
        if (location.path() !== '') {
          this.path = location.path().slice(1);
        } else {
          this.path = '/';
        }
      });
    }

  public getWindow(): Window | null {
    return this._doc.defaultView;
  }

  public googtics = (evt, categoria, accion, etiqueta) => {
    if(this.localStorage.getItem("idProductoSeleccionado") === this.localStorage.getItem("idProductoTradicional") || this.localStorage.getItem("idProductoSeleccionado") === undefined){

      this.getWindow()['dataLayer'] = this.getWindow()['dataLayer'] || [];

      const cat = this.removeAccents(categoria).toLowerCase() ;
      const etqt = (this.removeAccents(etiqueta)).toLowerCase();

      if ( evt == 'atm.pageview') {
        this.getWindow()['dataLayer'].push({
          event: evt,
          pageHost: categoria,
          pagePath: accion,
          pageTitle: etqt
        });
      } else {
        this.getWindow()['dataLayer'].push({
          event: evt,
          eventCategory: cat,
          eventAction: accion,
          eventLabel: etqt
        });
      }
    }
  }
  public removeAccents = (str) => {
    const de = 'ÁÃÀÄÂÉËÈÊÍÏÌÎÓÖÒÔÚÜÙÛÑÇáãàäâéëèêíïìîóöòôúüùûñç?¿';
    const a = 'AAAAAEEEEIIIIOOOOUUUUNCaaaaaeeeeiiiioooouuuunc  ';
    const re = new RegExp('[ÁÃÀÄÂÉËÈÊÍÏÌÎÓÖÒÔÚÜÙÛÑÇáãàäâéëèêíïìîóöòôúüùûñç]' , 'g');

    return str.replace(re, match => a.charAt(de.indexOf(match)));
  }
}
